/* Cãomigo — lógica da página "forra" (igual à do Claude Design). Precisa de cmg-dc.js antes. */
(function () {
class Component extends DCLogic {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, this.state || {}, {
      img: 0, open: {}, cart: 0, added: false, par: false, bump: false, menu: false,
      seen: {}, armed: false, bar: false, live: '', hint: true
    }, this.demoState());
    var self = this;
    this.setRoot = function (el) { self.rootEl = el; };
    this.setCv = function (el) { self.cv = el; };
    this.setCta = function (el) { self.ctaEl = el; };
    ['add', 'addPar', 'toggleMenu', 'dmDown', 'dmMove', 'dmUp', 'dmKey', 'tick'].forEach(function (k) { if (self[k]) self[k] = self[k].bind(self); });
    this.rowT = {};
    ["limpar", "caixa", "envio"].forEach(function (id) { self.rowT[id] = function () { self.toggle(id); }; });
    this.picks = [0, 1, 2, 3].map(function (i) { return function () { self.setState({ img: i }); }; });
    this.GAL = [{"t": "Em uso.", "d": "O cão sentado na mala, a forra a cobrir o fundo e a aba.", "alt": "Cão sentado na forra preta com debrum laranja, na mala aberta, num campo."}, {"t": "Montada.", "d": "Fundo, laterais e aba do para-choques. O estojo ao lado.", "alt": "Forra montada numa carrinha, vazia, com o estojo pousado ao lado."}, {"t": "O material.", "d": "Matelassê em losango, debrum laranja e fecho de canto.", "alt": "Detalhe do matelassê, do debrum laranja e do fecho de canto da forra."}, {"t": "Na costa.", "d": "Depois da praia, a areia fica no pano.", "alt": "Cão de pé na forra, mala aberta junto à costa."}];
    this.dv = {};
    this.demoInit();
  }

  /* ---------- UI ---------- */
  toggle(id) { var o = Object.assign({}, this.state.open); o[id] = !o[id]; this.setState({ open: o }); }
  toggleMenu() { this.setState({ menu: !this.state.menu }); }
  add() {
    var self = this;
    this.setState({ cart: this.state.cart + 1, added: true, bump: true, live: "Forra de porta-bagagens adicionada ao carrinho." });
    clearTimeout(this._tA); clearTimeout(this._tB);
    this._tA = setTimeout(function () { self.setState({ added: false }); }, 1800);
    this._tB = setTimeout(function () { self.setState({ bump: false }); }, 460);
  }
  addPar() {
    if (this.state.par) return;
    var self = this;
    this.setState({ cart: this.state.cart + 1, par: true, bump: true, live: "Taça dobrável de silicone adicionada ao carrinho." });
    clearTimeout(this._tB);
    this._tB = setTimeout(function () { self.setState({ bump: false }); }, 460);
  }

  componentDidMount() {
    var self = this;
    this.reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var root = this.rootEl;
    var scrolls = document.documentElement.scrollHeight > (window.innerHeight || 0) + 80;
    if (root && scrolls && 'IntersectionObserver' in window && !this.reduce) {
      var vh = window.innerHeight || 800, seen = {};
      var els = root.querySelectorAll('[data-rv]');
      this.io = new IntersectionObserver(function (es) {
        var add = {}, n = 0;
        es.forEach(function (e) { if (e.isIntersecting) { add[e.target.getAttribute('data-rv')] = true; self.io.unobserve(e.target); n++; } });
        if (n) self.setState(function (s) { return { seen: Object.assign({}, s.seen, add) }; });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.top < vh * 0.92) seen[els[i].getAttribute('data-rv')] = true; else this.io.observe(els[i]);
      }
      this.setState({ seen: seen, armed: true });
    }
    if (this.ctaEl && 'IntersectionObserver' in window) {
      this.io2 = new IntersectionObserver(function (es) {
        var e = es[0]; var off = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (off !== self.state.bar) self.setState({ bar: off });
      }, { threshold: 0 });
      this.io2.observe(this.ctaEl);
    }
    this.setupCv();
  }
  componentWillUnmount() {
    if (this.io) this.io.disconnect();
    if (this.io2) this.io2.disconnect();
    if (this.ro) this.ro.disconnect();
    if (this.onWin) window.removeEventListener('resize', this.onWin);
    if (this.raf) cancelAnimationFrame(this.raf);
    var tw = this._tw || {}; for (var k in tw) cancelAnimationFrame(tw[k]);
    clearTimeout(this._tA); clearTimeout(this._tB);
  }

  /* ---------- palco do momento de assinatura ---------- */
  ease(x) {
    var x1 = .22, y1 = .61, x2 = .36, y2 = 1, t = x;
    for (var i = 0; i < 7; i++) {
      var bx = 3 * x1 * t * (1 - t) * (1 - t) + 3 * x2 * t * t * (1 - t) + t * t * t - x;
      var d = 3 * x1 * (1 - t) * (1 - t) + 6 * (x2 - x1) * t * (1 - t) + 3 * (1 - x2) * t * t;
      if (Math.abs(d) < 1e-6) break; t = Math.max(0, Math.min(1, t - bx / d));
    }
    return 3 * y1 * t * (1 - t) * (1 - t) + 3 * y2 * t * t * (1 - t) + t * t * t;
  }
  tween(key, to, ms, done) {
    var self = this, from = this.dv[key], tw = (this._tw = this._tw || {});
    cancelAnimationFrame(tw[key]);
    if (this.reduce || from === to) { this.dv[key] = to; this.changed(); if (done) done(); return; }
    var t0 = 0;
    var f = function (now) {
      if (!t0) t0 = now;
      var k = Math.min(1, (now - t0) / ms);
      self.dv[key] = from + (to - from) * self.ease(k); self.changed();
      if (k < 1) tw[key] = requestAnimationFrame(f); else if (done) done();
    };
    tw[key] = requestAnimationFrame(f);
  }
  stopTween(key) { var tw = this._tw || {}; cancelAnimationFrame(tw[key]); }
  changed() { this.kick(); this.status(); }
  kick() { if (!this.raf) this.raf = requestAnimationFrame(this.tick); }
  tick() { this.raf = 0; this.draw(); }
  setupCv() {
    var cv = this.cv; if (!cv || !cv.getContext) return;
    this.ctx = cv.getContext('2d');
    var self = this;
    this.fit();
    if (window.ResizeObserver) { this.ro = new ResizeObserver(function () { self.fit(); }); this.ro.observe(cv); }
    else { this.onWin = function () { self.fit(); }; window.addEventListener('resize', this.onWin); }
    this.status();
  }
  fit() {
    var cv = this.cv; if (!cv) return;
    var w = cv.clientWidth, h = cv.clientHeight; if (!w || !h) return;
    var d = Math.min(2, window.devicePixelRatio || 1);
    this.W = w; this.H = h; this.dpr = d;
    cv.width = Math.round(w * d); cv.height = Math.round(h * d);
    var vb = this.VB || [0, 0, this.DW, this.DH], cw = vb[2] - vb[0], ch = vb[3] - vb[1];
    var s = Math.min(w / cw, h / ch);
    this.s = s; this.ox = (w - cw * s) / 2 - vb[0] * s; this.oy = (h - ch * s) / 2 - vb[1] * s;
    this.draw();
  }
  begin() {
    var c = this.ctx; if (!c || !this.W) return null;
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.clearRect(0, 0, this.W * this.dpr, this.H * this.dpr);
    c.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    c.fillStyle = this.BG; c.fillRect(0, 0, this.W, this.H);
    var d = this.dpr * this.s;
    c.setTransform(d, 0, 0, d, this.dpr * this.ox, this.dpr * this.oy);
    return c;
  }
  scene() { var d = this.dpr * this.s; this.ctx.setTransform(d, 0, 0, d, this.dpr * this.ox, this.dpr * this.oy); }
  label(x, y, txt, o) {
    o = o || {};
    var c = this.ctx, px = this.ox + x * this.s, py = this.oy + y * this.s, fs = o.size || Math.max(12, Math.min(15, 14 * this.s * 1.25));
    c.save(); c.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    c.font = (o.weight || 600) + ' ' + fs + 'px Inter, -apple-system, "Segoe UI", sans-serif';
    c.textAlign = o.align || 'center'; c.textBaseline = 'middle';
    if (o.rot) { c.translate(px, py); c.rotate(o.rot); px = 0; py = 0; }
    c.globalAlpha = o.alpha == null ? 1 : o.alpha;
    if (o.bg) {
      var m = c.measureText(txt).width, pw = 7, ph = fs * .72;
      var bx = o.align === 'left' ? px - pw : (o.align === 'right' ? px - m - pw : px - m / 2 - pw);
      c.fillStyle = o.bg; this.rr(c, bx, py - ph, m + pw * 2, ph * 2, 5); c.fill();
    }
    c.fillStyle = o.color || '#2B2A28'; c.fillText(txt, px, py);
    c.restore();
  }
  rr(c, x, y, w, h, r) {
    var rs = typeof r === 'number' ? [r, r, r, r] : r;
    c.beginPath(); c.moveTo(x + rs[0], y); c.lineTo(x + w - rs[1], y); c.quadraticCurveTo(x + w, y, x + w, y + rs[1]);
    c.lineTo(x + w, y + h - rs[2]); c.quadraticCurveTo(x + w, y + h, x + w - rs[2], y + h); c.lineTo(x + rs[3], y + h);
    c.quadraticCurveTo(x, y + h, x, y + h - rs[3]); c.lineTo(x, y + rs[0]); c.quadraticCurveTo(x, y, x + rs[0], y); c.closePath();
  }
  poly(c, pts) { c.beginPath(); c.moveTo(pts[0][0], pts[0][1]); for (var i = 1; i < pts.length; i++) c.lineTo(pts[i][0], pts[i][1]); c.closePath(); }
  quilt(c, x0, y0, x1, y1, step, col) {
    c.save(); c.strokeStyle = col || 'rgba(255,255,255,.075)'; c.lineWidth = 1.2; c.beginPath();
    var h = y1 - y0;
    for (var i = x0 - h; i < x1 + h; i += step) { c.moveTo(i, y0); c.lineTo(i + h, y1); c.moveTo(i, y1); c.lineTo(i + h, y0); }
    c.stroke(); c.restore();
  }
  dim(c, x0, y0, x1, y1, col) {
    c.save(); c.strokeStyle = col || '#6E6961'; c.lineWidth = 1.5; c.beginPath(); c.moveTo(x0, y0); c.lineTo(x1, y1);
    var a = Math.atan2(y1 - y0, x1 - x0), nx = -Math.sin(a) * 7, ny = Math.cos(a) * 7;
    c.moveTo(x0 - nx, y0 - ny); c.lineTo(x0 + nx, y0 + ny); c.moveTo(x1 - nx, y1 - ny); c.lineTo(x1 + nx, y1 + ny); c.stroke(); c.restore();
  }
  pt(e) { var b = this.cv.getBoundingClientRect(); return { x: ((e.clientX - b.left) - this.ox) / this.s, y: ((e.clientY - b.top) - this.oy) / this.s }; }
  cl(v, a, b) { return Math.max(a, Math.min(b, v)); }
  lerp(a, b, t) { return a + (b - a) * t; }
  num(v, d) { return v.toFixed(d == null ? 1 : d).replace('.', ','); }
  noHint() { if (this.state.hint) this.setState({ hint: false }); }
  say(m, alerta) { if (m !== this.state.dmMsg || !!alerta !== !!this.state.dmAlerta) this.setState({ dmMsg: m, dmAlerta: !!alerta, stF: !this.state.stF }); }


  demoState() { return { dmMsg: '', dmAlerta: false, w: 100 }; }
  demoInit() {
    this.DW = 800; this.DH = 550; this.BG = '#E3DCCF'; this.VB = [128, 0, 672, 548];
    this.dv = { w: 100 }; this.wT = 100;
    var self = this;
    this.setW = function (e) { var w = parseInt(e.target.value, 10); if (isNaN(w)) w = 100; self.noHint(); self.wT = w; self.setState({ w: w }); self.tween('w', w, 320); };
  }
  draw() {
    var c = this.begin(); if (!c) return;
    var self = this, k = 2.9, cx = 400, W = this.dv.w * k, F = 103 * k, y0 = 112, y1 = 432;
    var bodyL = cx - W / 2 - 58, bodyR = cx + W / 2 + 58, forra = '#272624', viv = '#C9763A';
    // carro visto de cima
    c.fillStyle = '#5E5B55'; this.rr(c, bodyL, 34, bodyR - bodyL, 470, [40, 40, 34, 34]); c.fill();
    c.fillStyle = '#BDB3A2'; this.rr(c, cx - W / 2, 58, W, 54, [10, 10, 0, 0]); c.fill();
    c.fillStyle = '#CFC6B6'; c.fillRect(cx - W / 2, y0, W, y1 - y0);
    c.fillStyle = 'rgba(43,42,40,.05)'; for (var yy = y0 + 6; yy < y1; yy += 12) for (var xx = cx - W / 2 + 6; xx < cx + W / 2; xx += 12) c.fillRect(xx, yy, 2, 2);
    c.fillStyle = '#A59C8C'; c.fillRect(cx - W / 2 - 16, y0 - 54, 16, y1 - y0 + 54); c.fillRect(cx + W / 2, y0 - 54, 16, y1 - y0 + 54);
    c.fillStyle = '#4A4743'; this.rr(c, bodyL + 8, y1, bodyR - bodyL - 16, 72, [0, 0, 28, 28]); c.fill();
    // falhas nas beiras
    if (W > F + .5) {
      var g = (W - F) / 2;
      [cx - W / 2, cx + F / 2].forEach(function (gx) {
        c.save(); c.beginPath(); c.rect(gx, y0, g, y1 - y0); c.clip();
        c.strokeStyle = 'rgba(110,105,97,.6)'; c.lineWidth = 1.5; c.beginPath();
        for (var i = -400; i < 400; i += 9) { c.moveTo(gx + i, y0); c.lineTo(gx + i + 320, y1); } c.stroke(); c.restore();
      });
    }
    // forra
    var fw = Math.min(F, W), fx0 = cx - fw / 2;
    var piece = function (f) { f(); c.fillStyle = forra; c.fill(); c.save(); f(); c.clip(); self.quilt(c, bodyL - 40, 20, bodyR + 40, 520, 24); c.restore(); f(); c.strokeStyle = viv; c.lineWidth = 2.2; c.stroke(); };
    piece(function () { self.rr(c, fx0, 62, fw, 50, [8, 8, 0, 0]); });
    piece(function () { c.beginPath(); c.rect(fx0, y0, fw, y1 - y0); });
    piece(function () { c.beginPath(); c.rect(cx - W / 2 - 16, y0 - 50, 16, y1 - y0 + 50); });
    piece(function () { c.beginPath(); c.rect(cx + W / 2, y0 - 50, 16, y1 - y0 + 50); });
    var aw = fw * .84;
    piece(function () { self.rr(c, cx - aw / 2, y1, aw, 58, [0, 0, 14, 14]); });
    // medidas
    this.dim(c, cx - W / 2, 16, cx + W / 2, 16);
    this.dim(c, cx - F / 2, 528, cx + F / 2, 528);
    var wt = Math.round(this.dv.w);
    this.label(cx, 16, 'A tua mala: ' + wt + ' cm', { bg: '#E3DCCF' });
    this.label(cx, 528, 'A forra: 103 cm', { bg: '#E3DCCF' });
    if (W > F + .5) {
      var gcm = (this.dv.w - 103) / 2;
      if ((W - F) / 2 * this.s >= 16) {
        this.label(cx - W / 2 + (W - F) / 4, 272, 'falta ' + this.num(gcm, gcm % 1 > .05 ? 1 : 0) + ' cm', { rot: -Math.PI / 2, bg: '#FAF7F1', size: 12 });
        this.label(cx + W / 2 - (W - F) / 4, 272, 'falta ' + this.num(gcm, gcm % 1 > .05 ? 1 : 0) + ' cm', { rot: -Math.PI / 2, bg: '#FAF7F1', size: 12 });
      }
    }
    this.label(cx, 272, 'fundo', { color: '#FAF7F1' });
  }
  status() {
    var w = this.wT, g = (w - 103) / 2, d = g % 1 ? 1 : 0, m, al = false;
    if (w < 103) m = 'Cobre o fundo todo, com cerca de ' + this.num(-g, d) + ' cm de folga de cada lado.';
    else if (w === 103) m = 'Cobre o fundo à medida: 103 cm.';
    else { m = 'Faltam cerca de ' + this.num(g, d) + ' cm em cada beira. Escreve-nos antes de comprar.'; al = true; }
    this.say(m, al);
  }
  dmDown(e) { if (!this.W) return; try { this.cv.setPointerCapture(e.pointerId); } catch (x) {} this.drag = true; this.p0 = this.pt(e); this.w0 = this.wT; this.sg = this.p0.x < 400 ? -1 : 1; this.noHint(); }
  dmMove(e) {
    if (!this.drag) return; var p = this.pt(e);
    var w = Math.round(this.cl(this.w0 + this.sg * 2 * (p.x - this.p0.x) / 2.9, 80, 130));
    if (w !== this.wT) { this.wT = w; this.setState({ w: w }); this.tween('w', w, 140); }
  }
  dmUp() { this.drag = false; }
  dmKey(e) {
    var k = e.key, d = 0;
    if (k === 'ArrowRight' || k === 'ArrowUp') d = 1; else if (k === 'ArrowLeft' || k === 'ArrowDown') d = -1; else return;
    e.preventDefault(); this.noHint(); var w = this.cl(this.wT + d, 80, 130); this.wT = w; this.setState({ w: w }); this.tween('w', w, 200);
  }
  demoVals(v) {
    var s = this.state;
    v.setW = this.setW; v.wVal = s.w; v.wTxt = s.w + ' cm';
    return v;
  }


  renderVals() {
    var s = this.state, self = this;
    var gal = {};
    this.GAL.forEach(function (g, i) {
      var on = i === s.img;
      gal['a' + i] = on ? g.alt : ''; gal['c' + i] = on ? 'on' : '';
      gal['t' + i] = on ? 'th sel' : 'th'; gal['p' + i] = on ? 'true' : 'false';
      gal['k' + i] = self.picks[i];
    });
    var cur = this.GAL[s.img];
    var rvc = function (k) { return !s.armed ? '' : (s.seen[k] ? 'rv in' : 'rv'); };
    var o = s.open, rows = {};
    for (var id in this.rowT) { rows[id] = { cls: o[id] ? 'row is-open' : 'row', exp: o[id] ? 'true' : 'false', t: this.rowT[id] }; }
    var v = {
      yes: true, logoH: 40, logoFt: 40,
      preco: 54.9, precoPar: 11.9, precoCapa: 39.9, precoRede: 89, precoForra: 54.9, precoCinto: 15.9, precoTaca: 11.9,
      feats: ["Cobre o fundo, as laterais e as costas dos bancos", "Aba de para-choques: menos arranhões na pintura", "Velcro duplo e fechos nos cantos, sem ferramentas"],
      trust: [{"icone": "envio", "texto": "Envio grátis"}, {"icone": "devolucao", "texto": "Devolução em 14 dias"}, {"icone": "prazo", "texto": "10 a 15 dias úteis"}],
      specs: [{"rotulo": "Medidas", "valor": "103 × 180 cm"}, {"rotulo": "Paredes", "valor": "Cerca de 76 cm de altura"}, {"rotulo": "Tecido", "valor": "Poliéster Oxford acolchoado"}, {"rotulo": "Verso", "valor": "PVC antiderrapante"}, {"rotulo": "Fixação", "valor": "Velcro duplo e fechos nos 4 cantos"}, {"rotulo": "Arrumação", "valor": "Estojo acolchoado incluído"}],
      factos: [{"titulo": "Envio grátis", "texto": "Para Portugal e 13 países da UE, sem mínimo."}, {"titulo": "10 a 15 dias úteis", "texto": "Sai de armazém internacional."}, {"titulo": "Devolução em 14 dias", "texto": "Sem justificação. Trocamos ou devolvemos o dinheiro."}, {"titulo": "Resposta em 1 dia útil", "texto": "caomigo.pt@gmail.com"}],
      gal: gal, capT: cur.t, capD: cur.d,
      ctaLabel: s.added ? 'Adicionado ao carrinho' : 'Adicionar ao carrinho',
      ctaShort: s.added ? 'Adicionado' : 'Adicionar ao carrinho', ctaCls: s.added ? 'cta-l on' : 'cta-l', added: s.added,
      parLabel: s.par ? "Taça adicionada" : "Adicionar a taça",
      add: this.add, addPar: this.addPar, liveMsg: s.live,
      hasCart: s.cart > 0, cart: s.cart, bdgCls: s.bump ? 'bdg bump' : 'bdg',
      cartLabel: s.cart > 0 ? 'Carrinho, ' + s.cart + (s.cart === 1 ? ' artigo' : ' artigos') : 'Carrinho, vazio',
      menuExp: s.menu ? 'true' : 'false', toggleMenu: this.toggleMenu, mnavCls: s.menu ? 'mnav is-open' : 'mnav',
      rows: rows,
      rv: { chips: rvc('chips'), foto: rvc('foto'), demo: rvc('demo'), ph: rvc('ph'), passos: rvc('passos'), det: rvc('det'), faq: rvc('faq'), relh: rvc('relh'), rel: rvc('rel'), fac: rvc('fac') },
      setRoot: this.setRoot, setCv: this.setCv, setCta: this.setCta,
      dmDown: this.dmDown, dmMove: this.dmMove, dmUp: this.dmUp, dmKey: this.dmKey,
      dmMsg: s.dmMsg, stCls: (s.dmAlerta ? 'dm-st alerta' : 'dm-st') + (s.stF ? ' f1' : ' f0'), hintCls: s.hint ? 'dm-hint' : 'dm-hint off',
      barCls: s.bar ? 'mbar on' : 'mbar', barHidden: s.bar ? 'false' : 'true'
    };
    return this.demoVals(v);
  }
}
(window.CMG = window.CMG || {}).pages = window.CMG.pages || {};
window.CMG.pages['forra'] = Component;
if (window.CMG.mountAll) window.CMG.mountAll();
})();
